import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import Confirm from "./pages/Confirm";
import Unsubscribed from "./pages/Unsubscribed";
import UnsubscribeConfirm from "./pages/UnsubscribeConfirm";
import OGImage from "./pages/OGImage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import CampaignDays from "./pages/admin/CampaignDays";
import Subscribers from "./pages/admin/Subscribers";
import EmailLogs from "./pages/admin/EmailLogs";
import AuditLogs from "./pages/admin/AuditLogs";
import Settings from "./pages/admin/Settings";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <Sentry.ErrorBoundary fallback={<div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <h1 className="text-2xl font-bold mb-2">Something went wrong</h1>
      <p className="text-gray-600">We've been notified and will fix this soon.</p>
    </div>
  </div>}>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/confirm" element={<Confirm />} />
            <Route path="/unsubscribe-confirm" element={<UnsubscribeConfirm />} />
            <Route path="/unsubscribed" element={<Unsubscribed />} />
            <Route path="/og-image" element={<OGImage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="days" element={<CampaignDays />} />
              <Route path="subscribers" element={<Subscribers />} />
              <Route path="logs" element={<EmailLogs />} />
              <Route path="audit" element={<AuditLogs />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);

export default App;
